import {Icon} from 'semantic-ui-react';


export const menuJson = [
    {
        "name": "Home",
        "to": "/",
        "display": <span><Icon name = {"home"}/>   Home </span>
    },
    {
        "name": "Services",
        "to": "/services",
        "display": <span><Icon name = {"book"}/>   Services </span>
    }
]